<template>
  <div>
    <div id="wrapper">
      <img src="../assets/my/2026.png" style="height:120px;"/>
      <div id="content" style="height:690px;">
        <p style="font-size:large; float:none;">
          <strong>Venue</strong>
        </p>
        <p>
          The IEEE BIBM 2026 main conference will be held in Dallas, USA, December 1-4, 2026.
        </p>
        <p>
          Please refer to the <a href="https://www3.cs.stonybrook.edu/~bibm2026/">BIBM 2026 main conference website</a> for venue and hotel information.
        </p>
      </div>
    </div>
    <footer-component></footer-component>
  </div>
</template>

<script>
  import FooterComponent from '@/components/Foot/footer.vue'

  export default {
    components: {
      FooterComponent
    }
  }
</script>

<style>
</style>
